import { CollaborationResult } from '@descomplica/microfrontend-core';
import { ICollaboration } from '@descomplica/microfrontend-core';
import { inject, injectable } from 'tsyringe';

import type {
  CreateRoleDto,
  IPegasusIOGateway,
  RoleDto,
} from '../../../../../shared/application/interfaces/pegasus-io.gateway';

@injectable()
export class CreateRoleCollaboration
  implements ICollaboration<CreateRoleDto, CollaborationResult<RoleDto>>
{
  constructor(
    @inject('IPegasusIOGateway')
    private readonly pegasusIOGateway: IPegasusIOGateway,
  ) {}

  public async run(dto: CreateRoleDto): Promise<CollaborationResult<RoleDto>> {
    return this.pegasusIOGateway.createRole(dto);
  }
}
